/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import { groupBy } from 'lodash';
import { useHistory } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import PaginationBox from '../../../../SharedModules/PaginationBox/PaginationBox';
import {
  getndcdetailsgrid,
  getndcDetailsGridForExportAll,
  setExportAllData,
  setLoading,
  setNDCDetailsData,
  setPaginationIndex,
} from '../Store/actions';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import { TableHead } from './TableHead';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { exportAllPDF } from '../../NDCHistory/Components/exportAll';
import {
  PAGINATION_EMPTY_ERR,
  PAGINATION_NEGATIVE_ERR,
  PAGINATION_OVER_TOTAL_ERR,
} from '../../../../SharedModules/Errors/constantMessageData';
import { naviagteToNDCDetailsPageAction } from '../../../Display/NDC/store/action';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

const DisplayNDCDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    displayObj: {
      rebateProgrameName,
      searchResult = [],
      selectedNDC,
      rebateProgram,
      labelerTableData,
      countValue,
    },
    exportAllData,
    ndcreportdetaildata,
    isLoading,
  } = useSelector((state) => state?.sharedState?.NDCDetailsReducer);
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );

  const [rows, setRows] = React.useState([]);
  const [exportAllClicked, setExportAllClicked] = useState(false);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [count, setCount] = React.useState(countValue);
  const [labelerName, setLabelerName] = React.useState('');
  const [numOfApi, setNumOfApi] = useState(1);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [columnApi, setColumnApi] = React.useState(null);
  const [drugName, setDrugName] = React.useState('');
  const [ndc, setNDC] = React.useState('');
  const [labelerCode, setLablerCode] = React.useState('');
  const [paginationArray, setPaginationArray] = React.useState([
    // ...Array(selectedNDC.length).keys(),
  ]);
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);
  /*
    This function handle the side effect of next previios of pagination box
  */
  const handleClick = (type, value) => {
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
      else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
      else if (value > paginationArray.length)
        setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
      else {
        setErrorMessages([]);
        dispatch(setPaginationIndex(value));
      }
    }
  };

  // this function handle the vlue like text in input box
  const handleBlur = (value) => {
    // if (
    //   value < 1 ||
    //   parseInt(value) > paginationArray.length ||
    //   value === '' ||
    //   isNaN(value)
    // ) {
    //   dispatch(setPaginationIndex(0));

    //   setTimeout(() => {
    //     value < 1
    //       ? dispatch(setPaginationIndex(1))
    //       : dispatch(setPaginationIndex(paginationArray.length));
    //   }, 20);
    if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
    else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
    else if (value > paginationArray.length)
      setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
    else {
      setErrorMessages([]);
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };

  React.useEffect(() => {
    if (ndcreportdetaildata?.length > 0) {
      setPaginationArray([...Array(ndcreportdetaildata?.length).keys()]);
    }
  }, [ndcreportdetaildata]);

  // On pagination change API get called from here
  React.useEffect(() => {
    if (count && ndcreportdetaildata) {
      // dispatch(setNDCDetailsData([]));
      // dispatch(
      //   getndcdetailsgrid({
      //     drugSeqNum: [selectedNDC[count - 1]?.drugSeqNum],
      //     rebateProgramCd: rebateProgram,
      //   })
      // );

      // Sort ndcreportdetaildata by drugSeqNum
      const sortedData = [...ndcreportdetaildata].sort((a, b) => {
        return a.ndc.localeCompare(b.ndc);
      });

      // Grouping data by drugSeqNum
      const grpData = Object.groupBy(
        searchResult,
        ({ drugSeqNum }) => drugSeqNum
      );

      const tbdata = grpData[sortedData[count - 1]?.drugSeqNum];

      // Mapping sorted tbdata to create data
      const data = tbdata.map((item) => {
        return {
          ...item,
          adjustedUnits: parseFloat(
            item.numofunits - item.totreimbursedunits
          ).toFixed(4),
          totreimbursedunits: item.totreimbursedunits
            ? parseFloat(item.totreimbursedunits).toFixed(4)
            : '0.0000',
          numofunits: item.numofunits
            ? parseFloat(item.numofunits).toFixed(4)
            : '0.0000',
          disputedunits: item.disputedunits
            ? parseFloat(item.disputedunits).toFixed(4)
            : '0.0000',
          originalInvoiceAmount: parseFloat(
            (item.totreimbursedunits * item.invoiceunitrebateamt).toFixed(2)
          ),
          currentInvoiceAmount: parseFloat(
            (item.numofunits * item.drugunitrebateamt).toFixed(2)
          ),
          paid_amt: item.paid_amt
            ? parseFloat(item.paid_amt.toFixed(2))
            : '0.00',
        };
      });
      setRows(data);
      setDrugName(sortedData?.[count - 1]?.drugName);
      setNDC(sortedData?.[count - 1]?.ndc);
      setLablerCode(sortedData?.[count - 1]?.labelerCode);
      const labelerName = labelerTableData.find(
        (item) => item.labelerCode === sortedData[count - 1]?.labelerCode
      )?.labelerName;
      setLabelerName(labelerName || '');
    }
  }, [count]);

  // Result for NDC details grid set from here
  React.useEffect(() => {
    // const data = searchResult.map((item) => {
    //   return {
    //     ...item,
    //     adjustedUnits: parseFloat(
    //       item.numofunits - item.totreimbursedunits
    //     ).toFixed(4),
    //     totreimbursedunits: parseFloat(item.totreimbursedunits).toFixed(4),
    //     numofunits: parseFloat(item.numofunits).toFixed(4),
    //     disputedunits: parseFloat(item.disputedunits).toFixed(4),
    //     originalInvoiceAmount: parseFloat(
    //       (item.totreimbursedunits * item.drugunitrebateamt).toFixed(2)
    //     ),
    //     currentInvoiceAmount: parseFloat(
    //       (item.numofunits * item.drugunitrebateamt).toFixed(2)
    //     ),
    //     paid_amt: parseFloat(item.paid_amt.toFixed(2)),
    //   };
    // });
    // setRows(data);
  }, [searchResult]);

  // selected rebate program short descript is calculayted from here
  const rebatePrograme = rebateProgrameName;

  // const drugName = selectedNDC[count - 1]?.drugName
  //   ? selectedNDC[count - 1]?.drugName
  //   : '';
  // const ndc = selectedNDC[count - 1]?.ndc;
  // const labelerCode = selectedNDC[count - 1]?.labelerCode;

  // Below variable are used for PDF header
  const firstInfo = `Mfg: ${labelerCode} - ${labelerName}`;
  const secondInfo = `NDC: ${ndc}`;
  const thirdInfo = `${rebatePrograme}`;
  const fourthInfo = `Drug Name: ${drugName}`;

  function divideArray(array, parts) {
    const { length } = array;
    const partSize = Math.ceil(length / parts); // Calculate the size of each part

    const dividedParts = [];
    let index = 0;

    while (index < length) {
      dividedParts.push(array.slice(index, index + partSize));
      index += partSize;
    }

    return dividedParts;
  }

  const [exportFileName, setExportFileName] = React.useState(null);
  const exportAllTpPDF = (name) => {
    setExportFileName(name);
    setExportAllClicked(true);
    const selectedAllNDC = selectedNDC.map((item) => item.drugSeqNum);
    // Limit selectedAllNDC to the first 1000 records
    const limitedNDC = selectedAllNDC.slice(0, 1000);
    // Calculate the number of API calls required (2 in this case if limitedNDC has 1000 or more)
    const numOfApiCallRequired = Math.ceil(limitedNDC.length / 500); // Divide by 500 for two groups
    const dividedArray = divideArray(limitedNDC, numOfApiCallRequired);

    setNumOfApi(numOfApiCallRequired);
    dispatch(setExportAllData([], 'noData'));
    dispatch(
      getndcDetailsGridForExportAll(
        {
          rebateProgramCd: rebateProgram,
        },
        dividedArray
      )
    );
  };
  const onGridReady = (params) => {
    setColumnApi(params.columnApi);
  };
  useEffect(() => {
    if (numOfApi === Object.keys(exportAllData).length) {
      dispatch(setLoading(true));
      let allData = [];
      for (const key in exportAllData) {
        allData = [...allData, ...exportAllData[key]];
      }

      allData.sort((a, b) => {
        const qtrA = a.qtr || '';
        const qtrB = b.qtr || '';
        
        const parseQtr = (qtrStr) => {
          const match = qtrStr.match(/(\d+)Q(\d+)/);
          if (match) {
            return { quarter: parseInt(match[1], 10), year: parseInt(match[2], 10) };
          }
          return { quarter: 0, year: 0 };
        };
        
        const qtrAObj = parseQtr(qtrA);
        const qtrBObj = parseQtr(qtrB);
        if (qtrAObj.year !== qtrBObj.year) {
          return qtrBObj.year - qtrAObj.year;
        }
        
        return qtrBObj.quarter - qtrAObj.quarter;
      });

      allData = allData.map((item) => {
        return {
          ...item,

          adjustedUnits: parseFloat(
            item.numofunits - item.totreimbursedunits
          ).toFixed(4),
          totreimbursedunits: parseFloat(item.totreimbursedunits).toFixed(4),
          numofunits: parseFloat(item.numofunits).toFixed(4),
          disputedunits: parseFloat(item.disputedunits)?.toFixed(4),
          originalInvoiceAmount: parseFloat(
            (item.totreimbursedunits * item.invoiceunitrebateamt).toFixed(2)
          ),
          currentInvoiceAmount: parseFloat(
            (item.numofunits * item.drugunitrebateamt).toFixed(2)
          ),
        };
      });
      const groupedData = groupBy(allData, 'drugSeqNum');
      const header = {
        reportName: 'NDC Details Report',
        fileName: exportFileName ? exportFileName : 'NDC Details Report',
      };

      const mapping = {};
      const labelerMapping = {};
      for (let i = 0; i < labelerTableData.length; i += 1) {
        labelerMapping[labelerTableData[i].labelerCode] =
          labelerTableData[i].labelerName;
      }
      for (let i = 0; i < selectedNDC.length; i += 1) {
        mapping[selectedNDC[i].drugSeqNum] = {
          ...selectedNDC[i],
          labelerName: labelerMapping[selectedNDC[i].labelerCode],
        };
      }
      const options = {
        info: { thirdInfo },
        titleName: 'Drug Seq Num: ',
        mapping,
        pageSize: {
          height: 800,
          width: 1500,
        },
      };
      const paginationArr = [];
      const widths = [];
      if (exportAllClicked) {
        setExportAllClicked(false);
        exportAllPDF(
          header,
          groupedData,
          columnApi,
          userDefaults,
          options,
          paginationArr,
          widths,
          logInUser
        );
      }
      dispatch(setLoading(false));
    }
  }, [exportAllData]);

  const goToNdcPage = () => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === '/ndc-details') === -1) {
      updateTabs.push({
        navTo: '/ndc-details',
        value: 'NDC Details',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: '/ndc-details',
    });
  };

  // navigate
  const navigateHandler = (value) => {
    if (value == 'NDC') {
      dispatch(
        naviagteToNDCDetailsPageAction({
          succesFunc: () => {
            goToNdcPage();
          },
          ndcDetailsTableData: [
            {
              ndc,
              drugName,
            },
          ],
        })
      );
    }
  };
  return (
    <div className="tabs-container">
      <CustomSeparator parent1="Detail Reports" parent2="Display NDC Details" />
      <Spinner load={isLoading} />
      <DisplayErrorMessages errorMessages={errorMessages} />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-5">
                      <div className="col-12">
                        <div className="float-right">
                          <PaginationBox
                            array={paginationArray}
                            count={count}
                            handleClick={handleClick}
                            handleBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Rebate Program: "
                          id="Rebate Program"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={rebatePrograme}
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          label="NDC: "
                          id="NDC"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={ndc}
                        />
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Manufacturer Id: "
                          id="Manufacturer Id"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={labelerCode}
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          label="Name: "
                          id="Name"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={labelerName}
                        />
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Drug Name: "
                          id="Drug Name"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={drugName}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="row" style={{ marginTop: 15 }}>
          <div className="unallocated" style={{ width: '100vw' }}>
            <TableGridWithFeatures
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              columnDefs={TableHead}
              gridCall={onGridReady}
              rowData={rows || []}
              data-testid="onEditingStopped"
              enterMovesDown
              showResetFilter={false}
              noGlobalSort
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              countValue={count}
              hideTotalCount={false}
              exportFile
              reportName="NDC Details Report"
              fileName="NDCDetails"
              fullScreenView={fullScreenView}
              exportAllTpPDF={exportAllTpPDF}
              handleFullScreenViewClick={changeFullScreenView}
              info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
              navigateHandler={navigateHandler}
              showGoToNDCOptions
              isScrollOn
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;

                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name && `${name.substring(0, 20)}...`}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisplayNDCDetails;
